import getScenarioStore from './getScenarioStore';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default function isSearchBoxEmpty(scenarioId: SearchScenarioId) {
    const store = getScenarioStore(scenarioId);

    return (
        store.searchText.trim().length === 0 &&
        store.suggestionPillIds.length === 0 &&
        store.suggestionSegments.size === 0
    );
}
